import React, { useEffect, useState } from "react";
import JobCard from "./JobCard";
import { JobCardData } from "../../../DataModels/DataModels";
import CardList from "./CardList";
import { SortMenu, SortFunction, defaultSort } from "../Menu/SortMenu";

interface JobStateProps {
	title: string;
	jobCards: JobCardData[];
	className?: string;
	renderTutorial?: boolean;
	isDemo?: boolean;
}

const JobStateColumn: React.FC<JobStateProps> = ({
	title,
	jobCards,
	className = "",
	renderTutorial = false,
	isDemo = false
}) => {
	const [jobCardList, setJobCardList] = useState([...jobCards]);
	const [sortFunc, setSortFunc] = useState<SortFunction<JobCardData>>(
		() => defaultSort
	);

	const handleSortChange = (option: any) => {
		setSortFunc(() => option.func);
	};

	useEffect(() => {
		if (sortFunc) setJobCardList([...jobCards].sort(sortFunc));
	}, [jobCards, sortFunc]);

	return (
		<div className="bg-primary-accent rounded-2xl p-4 border border-primary-inactive h-full flex flex-col">
			{/* Header */}
			<div className="flex items-center justify-between mb-4">
				<div className="flex items-center gap-2">
					<h2 className="text-primary font-medium text-lg">{title}</h2>
					{jobCards.length > 3 && (
						<span className="text-primary text-sm">- {jobCards.length}</span>
					)}
				</div>

				{/* Sort Dropdown */}
				{jobCards.length > 3 && (
					<SortMenu
						isTitle={false}
						badgeClass="text-primary hover:text-primary-background"
						onClick={handleSortChange}
					/>
				)}
			</div>

			{/* Job Cards */}
			{jobCards.length > 0 && (
				<CardList className={className}>
					{jobCardList.map((job, index: number) => (
						<JobCard key={index} data={job} isDemo={isDemo} />
					))}
				</CardList>
			)}

			{/* Empty State */}
			{jobCards.length <= 0 && !renderTutorial && (
				<div
					className={`flex flex-col items-center justify-center text-primary ${className}`}
				>
					<p className="text-sm">No jobs in this state</p>
				</div>
			)}
			{jobCards.length <= 0 && renderTutorial && (
				<div
					className={`flex flex-col items-center justify-center text-primary p-4 border rounded-2xl border-primary-inactive border-dashed `}
				>
					<p className="text-sm">Use the "Track" button to start tracking</p>
					<p className="text-sm">your jobs and they will be placed here.</p>
				</div>
			)}
		</div>
	);
};

export default JobStateColumn;
